import { Injectable } from '@angular/core';
import { MenuItem } from '../models/models';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  readonly menuItems: MenuItem[] = [
    {
      id: 'base-info',
      label: 'Informazioni di base',
      icon: 'user-circle',
      children: [
        {
          id: 'dati-societari',
          label: 'Profilo organizzazione',
          icon: '',
          route: '/base-info/dati-societari',
        },
        {
          id: 'informazioni-di-contatto',
          label: 'Informazioni di contatto',
          icon: '',
          route: '/base-info/informazioni-di-contatto',
        },
      ],
    },
    {
      id: 'document-typology',
      label: 'Tipologia documenti – dati analisi',
      icon: 'document-text',
      children: [
        {
          id: 'fatture-elettroniche-xml',
          label: 'Fatture Elettroniche XML',
          icon: '',
          route: '/document-typology/fatture-elettroniche-xml',
        },
        {
          id: 'fatture-cartacee-pdf',
          label: 'Fatture Cartacee/PDF',
          icon: '',
          route: '/document-typology/fatture-cartacee-pdf',
        },
        {
          id: 'scritture-libri-contabili',
          label: 'Scritture Libri Contabili',
          icon: '',
          route: '/document-typology/scritture-libri-contabili',
        },
        {
          id: 'altri-documenti-rilevanza-contabile',
          label: 'Altri documenti di rilevanza contabile',
          icon: '',
          route: '/document-typology/altri-documenti-rilevanza-contabile',
        },
        {
          id: 'dichiarazioni-comunicazioni-amministrazione-finanziaria',
          label: 'Dichiarazioni e comunicazioni inviate all’amministrazione finanziaria',
          icon: '',
          route: '/document-typology/dichiarazioni-comunicazioni-amministrazione-finanziaria',
        },
        {
          id: 'messaggi-posta-elettronica-certificata-pec',
          label: 'Messaggi di posta elettronica certificata (PEC)',
          icon: '',
          route: '/document-typology/messaggi-posta-elettronica-certificata-pec',
        },
        {
          id: 'libro-unico-del-lavoro-lul',
          label: 'Libro unico del lavoro – LUL',
          icon: '',
          route: '/document-typology/libro-unico-del-lavoro-lul',
        },
        {
          id: 'altre-tipologie-documentali',
          label: 'Altre tipologie documentali',
          icon: '',
          route: '/document-typology/altre-tipologie-documentali',
        },
        {
          id: 'rentri-registro-elettronico-tracciabilita-rifiuti',
          label: 'Rentri - Registro elettronico per la tracciabilità dei rifiuti',
          icon: '',
          route: '/document-typology/rentri-registro-elettronico-tracciabilita-rifiuti',
        },
      ],
    },
    {
      id: 'conservatori-user',
      label: 'Conservatori',
      icon: 'archive',
      route: '/conservatori-user',
    },
    {
      id: 'tipologie-documenti-report',
      label: 'Tipologie documenti - report',
      icon: 'clipboard-list',
      route: '/tipologie-documenti-report',
    },
    {
      id: 'documenti-servizio-rdc',
      label: 'Documenti servizio RDC',
      icon: 'briefcase',
      route: '/documenti-servizio-rdc',
    },
    {
      id: 'monitoring',
      label: 'Monitoraggio',
      icon: 'chart-line',
      // route: '/monitoring',
    },
  ];
}
